import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

const BCSelectField = (props) => {
    const { controlId, dropDownLabel, label, size, onChange, data, ...rest } = props;
    const [field, meta] = useField(props);

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...rest}
                {...field}
                onChange={onChange}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
            >
                <option>{dropDownLabel}</option>
                {data?.map((item, idx) => (
                    <option value={item.id} key={idx}>
                        {item.name}
                    </option>
                ))}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BCSelectField.defaultProps = {
    data: [],
    dropDownLabel: null,
    size: "md"
};

export default BCSelectField;
